import { render, staticRenderFns } from "./systemLayOut.vue?vue&type=template&id=9ff9ca66"
import script from "./systemLayOut.vue?vue&type=script&lang=js"
export * from "./systemLayOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports